export default __webpack_public_path__ + "static/media/mussen-nest-plattegrond.8e4dd5e4.pdf";